var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216.3 273.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;stroke:#fff;stroke-width:10px;}.cls-1{stroke-linecap:round;}.cls-1,.cls-2{stroke-linejoin:round;}.cls-3{stroke-linejoin:bevel;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.67,5H165.62A45.67,45.67,0,0,1,211.3,50.67v66.41a94.78,94.78,0,0,1-94.78,94.78H99.78A94.78,94.78,0,0,1,5,117.08V50.67A45.67,45.67,0,0,1,50.67,5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 59.37,
    y: 212.99,
    width: 96.98,
    height: 55.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 59.8,
    y1: 230.41,
    x2: 157.07,
    y2: 252.2
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "177.09 120.86 177.09 59.48 153.08 59.48 153.08 118.72 128.4 118.72 128.4 60.02 106.11 60.02 106.11 116.59 79.71 116.59 79.71 61.08 57.77 61.08 57.77 114.99 37.17 114.99 36.91 57.88"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/Projects.650d495ab94cd9c22ae820f717e3a22e.svg";
export { ForwardRef as ReactComponent };